import { fetchJsonResponse } from '@/ai/api'
import { buildSingleCardPrompt } from '@/ai/prompts'

export const generateSingleCard = async ({
  eventId,
  workflow,
  cardTypes,
  cardTypeId,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildSingleCardPrompt({
    eventId,
    workflow,
    cardTypes,
    cardTypeId
  })

  const response = await fetchJsonResponse({
    messages,
    useCase: 'cards',
    aiVersion: workflow.aiVersion,
    signal: abortController?.signal
  })

  return response || null
}
